import React from 'react';
import { ArrowLongIcon } from './arrowLong.icon';
import { ArrowShortIcon } from './arrowShort.icon';
import { BacklogIcon } from './backlog.icon';
import { BookMarkIcon } from './bookMark.icon';
import { CalendarIcon } from './calendar.icon';
import { ChainsIcon } from './chains.icon';
import { ChartIcon } from './chart.icon';
import { ChevronsLeftIcon } from './chevronsLeft.icon';
import { ChevronsRightIcon } from './chevronsRight.icon';
import { CityIcon } from './city.icon';
import { ColorIcon } from './color.icon';
import { CountryIcon } from './country.icon';
import { CrossIcon } from './cross.icon';
import { DisconnectIcon } from './disconnect.icon';
import { EditBoxIcon } from './editBox.icon';
import { EmailIcon } from './email.icon';
import { EngagementIcon } from './engagement.icon';
import { EventManagerIcon } from './eventManager.icon';
import { EyeIcon } from './eye.icon';
import { EyeOffIcon } from './eyeOff.icon';
import { FirstnameIcon } from './firstname.icon';
import { FolderOpenLightIcon } from './folderOpenLight.icon';
import { FolderOpenSolidIcon } from './folderOpenSolid.icon';
import { GearIcon } from './gear.icon';
import { GripIcon } from './grip.icon';
import { HelpIcon } from './help.icon';
import { HourglassIcon } from './hourglass.icon';
import { LanguageIcon } from './language.icon';
import { LastnameIcon } from './lastname.icon';
import { MagnifyingGlassMinusIcon } from './magnifyingGlassMinus.icon';
import { MagnifyingGlassIcon } from './magnifyingGlass.icon';
import { MagnifyingGlassPlusIcon } from './magnifyingGlassPlus.icon';
import { MinusIcon } from './minus.icon';
import { NewsIcon } from './news.icon';
import { NewsCheckIcon } from './newsCheck.icon';
import { NewsDeleteIcon } from './newsDelete.icon';
import { NewsPlusIcon } from './newsPlus.icon';
import { NoDataAvailableIcon } from './noDataAvailable';
import { PieChartIcon } from './pieChart.icon';
import { PlusIcon } from './plus.icon';
import { QuestionMarkIcon } from './questionMark.icon';
import { SaveIcon } from './save.icon';
import { SharedIcon } from './shared.icon';
import { SortIcon } from './sort.icon';
import { SortArrowDownIcon } from './sortArrowDown.icon';
import { SortArrowUpIcon } from './sortArrowUp.icon';
import { TimerIcon } from './timer.icon';
import { TitleIcon } from './title.icon';
import { TrashIcon } from './trash.icon';
import { UserIcon } from './user.icon';
import { NotesIcon } from './notes.icon';

export const icons = {
  ArrowLongIcon,
  ArrowShortIcon,
  BacklogIcon,
  BookMarkIcon,
  CalendarIcon,
  ChainsIcon,
  ChartIcon,
  ChevronsLeftIcon,
  ChevronsRightIcon,
  CityIcon,
  ColorIcon,
  CountryIcon,
  CrossIcon,
  DisconnectIcon,
  EditBoxIcon,
  EmailIcon,
  EngagementIcon,
  EventManagerIcon,
  EyeIcon,
  EyeOffIcon,
  FirstnameIcon,
  FolderOpenLightIcon,
  FolderOpenSolidIcon,
  GearIcon,
  GripIcon,
  HelpIcon,
  HourglassIcon,
  LanguageIcon,
  LastnameIcon,
  MagnifyingGlassIcon,
  MagnifyingGlassMinusIcon,
  MagnifyingGlassPlusIcon,
  MinusIcon,
  NewsIcon,
  NewsCheckIcon,
  NewsDeleteIcon,
  NewsPlusIcon,
  NoDataAvailableIcon,
  PieChartIcon,
  PlusIcon,
  QuestionMarkIcon,
  SaveIcon,
  SharedIcon,
  SortIcon,
  SortArrowUpIcon,
  SortArrowDownIcon,
  TimerIcon,
  TitleIcon,
  TrashIcon,
  UserIcon,
  NotesIcon
};

const IconsGallery: React.FC = () => {
  return (
    <div className='grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-6 p-4'>
      {Object.entries( icons ).map( ( [ name, ICON ] ) => {return (
        <div
          key={name}
          className='flex flex-col items-center justify-center p-4 border border-gray-200 rounded-md shadow-sm hover:shadow-md transition-shadow bg-white text-center'
        >

          <ICON />
          <span className='mt-2 text-sm break-words'>{name}</span>
        </div>
      );} )}
    </div>
  );
};

export default IconsGallery;